<template>
  <div class="campaignCreatives">
    <div class="pageContent">
      <heading-wrap v-if="campaign">
        <span slot="title">Campaign Name: {{ this.campaign.name }} </span>
        <span slot="link">
          <button-cta v-if="!isClient" data-modalType="createCampaign" :onClick="onLaunchModal" class="btn btn-primary pull-right">Create Creative</button-cta>
        </span>
      </heading-wrap>

      <div class="row">
        <div class="col-sm-6">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Client: <router-link :to="{ path: `/client/${this.campaign.client.hash_id}` }">{{ this.campaign.client.name }}</router-link></h5>
              <h5 class="card-title">Campaign Job Number: {{ this.campaign.campaign_job_number }}</h5>
              <h5 class="card-title">Status: <span v-if="this.campaign.is_archived" class="label label-pill label-warning">Archived</span><span v-else class="label label-pill label-success">Active</span></h5>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <search-box v-model="search" name="Creatives..." />

      <spinner-icon v-if="loading" />
      <slot-table :data="filteredCreatives" :columns="table.columns">
        <template slot="name" slot-scope="props">
          <router-link :to="{ path: `/creatives/${props.item.hash_id}/bulk` }">
            {{ props.item.name }}
          </router-link>
        </template>
        <template slot="type" slot-scope="props">
          <span class="text-uppercase">{{ props.item.type === 'html-video' ? 'VIDEO (HTML)' : props.item.type}}</span>
        </template>
        <template slot="creative_job_number" slot-scope="props">
          <span>{{ props.item.creative_job_number }}</span>
        </template>
        <template slot="status" slot-scope="props">
          <span class="label label-pill text-capitalize" :class="getStatusClass(props.item.status)">{{ props.item.status.replaceAll('_',' ') }}</span>
        </template>
        <template slot="date_created" slot-scope="props">
          <span>{{props.item.date_created.value | formatDate }}</span>
        </template>
        <template slot="date_updated" slot-scope="props">
          <span>{{props.item.date_updated.value | formatDate }}</span>
        </template>

        <template slot="creativeActions" slot-scope="props">
              <span v-if="props.item.creativeActions">
                <button-cta :style="{width: '2.5rem'}" v-if="props.item.type === 'after-effects' && profileUser.role === 1" data-modalType="alterAeCreative" :data-modalId="props.item.hash_id" :onClick="onLaunchModal" title="Update creative" class="btn btn-info btn-xs">
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </button-cta>
                <button-cta :style="{width: '2.5rem'}" v-if="props.item.childs.length === 0 && (profileUser.role === 1 || profileUser.role === 2 || profileUser.role === 4)" title="create association" data-modalType="creativeAssociate" :data-modalId="props.item.hash_id" :onClick="onLaunchModal" class="btn btn-info btn-xs">
                  <i class="fa fa-handshake-o" aria-hidden="true"></i>
                </button-cta>
                <button-cta :style="{width: '2.5rem'}" v-else-if="!isClient" title="edit associations" :data-modalField="getString(props.item.childs)" data-modalType="editCreativeAssociate" :data-modalId="props.item.hash_id" :onClick="editAssociationsCallback" class="btn btn-info btn-xs">
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                </button-cta>
                <button-cta v-if="!isClient || (isClient && !props.item.is_duplicate)" title="clone" data-modalType="cloneCreative" :data-modalId="props.item.hash_id" :onClick="onLaunchModal" class="btn btn-success btn-xs">
                  <i class="fa fa-clone" aria-hidden="true"></i>
                </button-cta>
                <button-cta title="cancel all renders requests" data-modalType="cancelRendersRequests" :data-modalField="props.item.name" :data-modalID="props.item.hash_id" :onClick="onLaunchModal" class="btn btn-danger btn-xs">
                  <i class="fa fa-times-circle" aria-hidden="true"></i>
                </button-cta>
                <button-cta title="edit fields" data-modalType="editCreative" :data-modalField="props.item.name" :data-modalID="props.item.hash_id" :onClick="onLaunchModal" class="btn btn-warning btn-xs">
                  <i class="fa fa-edit" aria-hidden="true"></i>
                </button-cta>
                <button-cta v-if="!isClient || (isClient && props.item.is_duplicate)" title="delete" data-modalType="deleteCreative" :data-modalID="props.item.hash_id" :onClick="onLaunchModal" class="btn btn-danger btn-xs">
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button-cta>
                <router-link :to="{ path: `/tags/creative/${props.item.hash_id}` }" class="btn btn-xs btn-info" v-if="props.item.has_tags">
                  <i class="fa fa-tag" aria-hidden="true"></i>
                </router-link>
              </span>
        </template>

      </slot-table>
    </div>

    <portal to="globalModal">
      <modal-create-campaign :show="showModal.createCampaign" :goToStep="2" @close="toggleModal('createCampaign')" />
      <modal-clone-creative :show="showModal.cloneCreative" :creativeId="modalId" :type="modalType" :confirmId="modalId" :field="modalField" @close="toggleModal('cloneCreative')" />
      <modal-edit-creative :show="showModal.editCreative" :type="modalType" :confirmId="modalId" :field="modalField" @close="toggleModal('editCreative')"/>
      <modal-delete-creative :show="showModal.deleteCreative" :type="modalType" :confirmId="modalId" @close="toggleModal('deleteCreative')"/>
      <modal-creative-associate :show="showModal.creativeAssociate" :type="modalType" :confirmId="modalId" :field="modalField" @close="toggleModal('creativeAssociate')" />
      <modal-edit-creative-associate :show="showModal.editCreativeAssociate" :type="modalType" :confirmId="modalId" :field="modalField" @close="toggleModal('editCreativeAssociate')" />
      <modal-alter-ae-creative :show="showModal.alterAeCreative" :type="modalType" :confirmId="modalId" @close="toggleModal('alterAeCreative')" />
      <modal-cancel-renders-requests :show="showModal.cancelRendersRequests" :type="modalType" :confirmId="modalId" @close="toggleModal('cancelRendersRequests')" />
    </portal>

  </div>
</template>

<script>
import HeadingWrap from '@/components/HeadingWrap/heading-wrap'
import SlotTable from '@/components/Table/table'
import ButtonCta from '@/components/Button/button'
import SpinnerIcon from '@/components/SpinnerIcon/spinner'
import ModalCloneCreative from '@/components/Modal/creatives/modal-clone-creative'
import ModalEditCreative from '@/components/Modal/creatives/modal-edit-creative'
import ModalDeleteCreative from '@/components/Modal/creatives/modal-delete-creative'
import ModalCreateCampaign from '@/components/Modal/campaigns/modal-create-campaign'
import ModalCreativeAssociate from '@/components/Modal/creatives/modal-creative-associate'
import ModalEditCreativeAssociate from '@/components/Modal/creatives/modal-edit-creative-associate'
import ModalAlterAeCreative from '@/components/Modal/creatives/modal-alter-ae-creative'
import ModalCancelRendersRequests from '@/components/Modal/creatives/modal-cancel-renders-requests'
import SearchBox from '@/components/SearchBox/searchbox'

import {campaignMixin} from '@/mixins/campaignMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {profileMixin} from '@/mixins/profileMixin'
import {modalMixin} from '@/mixins/modalMixin'

import { assoc, map } from 'ramda'

export default {
  name: 'campaignCreatives',
  mixins: [campaignMixin, creativeMixin, modalMixin, profileMixin],
  components: {
    HeadingWrap,
    SlotTable,
    ButtonCta,
    ModalEditCreative,
    ModalCloneCreative,
    ModalDeleteCreative,
    ModalCreateCampaign,
    ModalCreativeAssociate,
    ModalEditCreativeAssociate,
    ModalAlterAeCreative,
    ModalCancelRendersRequests,
    SpinnerIcon,
    SearchBox
  },
  data: () => ({
    search: ''
  }),
  methods: {
    getString (item) {
      return JSON.stringify(item)
    },
    getStatusClass (status) {
      switch (status) {
        case 'approved':
          return 'label-success'
        case 'approval_requested':
          return 'label-warning'
        default:
          return 'label-primary'
      }
    },
    editAssociationsCallback (e) {
      this.startLoading()
      this.getCreatives(this.$route.params.id).then(() => {
        this.finishLoading()
      })
      this.onLaunchModal(e)
    }
  },
  created () {
    this.startLoading()
    const id = this.$route.params.id
    this.getCampaign(id).then(() => {
      this.getCreatives(id).then(() => {
        this.finishLoading()
      })
    })
  },
  computed: {
    table () {
      if (this.isClient) {
        return {
          columns: {
            name: 'Creative Name',
            type: 'Type',
            creative_job_number: 'Creative Job Number',
            date_created: 'Date Created',
            date_updated: 'Date Updated',
            status: 'Status',
            creativeActions: ''
          }
        }
      }
      return {
        columns: {
          name: 'Creative Name',
          type: 'Type',
          creative_job_number: 'Creative Job Number',
          date_created: 'Date Created',
          date_updated: 'Date Updated',
          creativeActions: ''
        }
      }
    },
    filteredCreatives () {
      const formattedCreatives = map(item => assoc('creativeActions', true, item), this.creatives)
      return formattedCreatives.filter(creative => {
        return creative.name.toLowerCase().includes(this.search.toLowerCase()) || creative.type.toLowerCase().includes(this.search.toLowerCase()) || creative.creative_job_number.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    isClient () {
      return this.profileUser && this.profileUser.role === 6
    }
  }
}

</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/pages/campaigns/campaign-creatives.vue